export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/5860effcda061f4f05feb4a92be5a34c.svg";